import { createApp } from 'vue';

import SoldListings from '../components/sold/sold-listings.vue';

// Powers the sold listing surface on /list.
const app = createApp({
	template: `
		<SoldListings />
	`,
	components: {
		SoldListings
	}
});

app.config.compilerOptions.whitespace = 'preserve';
app.mount('#sold-listings');
